// Header.jsx
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faHome, faCalendar, faBell } from '@fortawesome/free-solid-svg-icons';
import { useNightMode } from '../NightModeContext';
import { useNavigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import '../Header.css';
import { useTasks } from '../Schedule/TaskContext';

const Header = ({ showBackgroundPicker, onBackgroundChange, videoSources, selectedVideoIndex }) => {
    const { isNightMode, toggleNightMode } = useNightMode();
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useTasks();
    const [showReminderModal, setShowReminderModal] = useState(false); // State to control the visibility of the mindfulness reminder modal
    const [reminders, setReminders] = useState([]);

    const showNotification = (title, body) => {
        if (Notification.permission === 'granted') {
          new Notification(title, { body });
        }
      };

    const addReminder = () => {
        const reminderType = document.getElementById('reminderType').value;
        const minutes = document.getElementById('reminderMinutes').value || "0"; // Treat empty input as "0"
        const seconds = document.getElementById('reminderSeconds').value || "0"; 
        const totalSeconds = parseInt(minutes) * 60 + parseInt(seconds);

        let countdown = totalSeconds;
        const countdownInterval = setInterval(() => {
            countdown -= 1;
            if (countdown <= 0) {
                clearInterval(countdownInterval);
                alert(`Time for your ${reminderType}!`);
            }
            // Update the state that displays the countdown time
            // You might need to add new state to track this
        }, 1000);

        // Close the modal
        setShowReminderModal(false);

        if (!('Notification' in window)) {
            alert('This browser does not support desktop notification');
          } else if (Notification.permission === 'granted') {
            // If it's okay, let's create a notification
            setTimeout(() => {
              showNotification('Mindfulness Reminder', `Time for your ${reminderType}!`);
            }, totalSeconds * 1000);
          } else if (Notification.permission !== 'denied' || Notification.permission === 'default') {
            // Otherwise, we need to ask the user for permission
            Notification.requestPermission().then((permission) => {
              if (permission === 'granted') {
                // If the user accepts, let's create a notification
                setTimeout(() => {
                  showNotification('Mindfulness Reminder', `Time for your ${reminderType}!`);
                }, totalSeconds * 1000);
              }
            });
          }
    };


    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/signin');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    // Determine if the user is on the home page
    const onHomePageOrSchedule = location.pathname === '/home' || location.pathname === '/schedule';
    const isOnHomePage = location.pathname === '/home';


    return (
        <header>
            <div className="header">
                <div className="left-section">
                    <FontAwesomeIcon
                        icon={faHome}
                        onClick={() => navigate("/home")}
                        className={`icon ${isNightMode ? 'night-mode' : ''}`}
                    />

                    <FontAwesomeIcon
                        icon={faCalendar}
                        onClick={() => navigate("/schedule")}
                        className={`icon ${isNightMode ? 'night-mode' : ''}`}
                        title="Schedule"
                    />

                    {showBackgroundPicker && onHomePageOrSchedule && videoSources && (
                        <div className="background-picker">
                            <select
                                onChange={onBackgroundChange}
                                className="video-selector"
                                value={selectedVideoIndex}  // use the prop for controlling the select value
                            >
                                <option value="" disabled>Select Background</option>
                                {videoSources.map((video, index) => (
                                    <option key={index} value={index}>
                                        {video.label}
                                    </option>
                                ))}
                            </select>

                        </div>
                    )}

                    {/* Show logout button only if the user is logged in and on the home or schedule page */}
                    {user && onHomePageOrSchedule && (
                        <button onClick={handleLogout} className="logout-button-text">Logout</button>
                    )}
                </div>
                <div className="right-section">
                    <FontAwesomeIcon
                        icon={faMoon}
                        onClick={toggleNightMode}
                        className={`icon moon-icon ${isNightMode ? 'night-mode' : ''}`}
                    />
                    <label className="switch" aria-label="Toggle Night Mode">
                        <input type="checkbox" checked={isNightMode} onChange={toggleNightMode} />
                        <span className="slider round"></span>
                    </label>

                    {isOnHomePage && (
                        <>
                            <FontAwesomeIcon
                                icon={faBell}
                                className={`icon bell-icon ${isNightMode ? 'night-mode' : ''}`}
                                title="Set Mindfulness Reminder"
                                onClick={() => setShowReminderModal(true)}
                            />
                            {showReminderModal && (
                                <div className="reminder-modal active">
                                    <h3>Set a Reminder</h3>
                                    <form onSubmit={(e) => e.preventDefault()} className="focus-timer-details">
                                        <label htmlFor="reminderType">Type:</label>
                                        <select id="reminderType" className="focus-timer-dropdown">
                                            <option value="mindfulness">Mindfulness Break</option>
                                            <option value="hydration">Hydration Reminder</option>
                                            <option value="break">Take a Break</option>
                                        </select>
                                        <label htmlFor="reminderMinutes">Minutes:</label>
                                        <input id="reminderMinutes" type="number" min="0" className="focus-timer-details input" />
                                        <label htmlFor="reminderSeconds">Seconds:</label>
                                        <input id="reminderSeconds" type="number" min="0" max="59" className="focus-timer-details input" />
                                        <div className="button-container">
                                            <button type="button" onClick={addReminder}>
                                                Set Reminder
                                            </button>
                                            <button type="button" onClick={() => setShowReminderModal(false)}>
                                                Close
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            )}
                        </>
                    )}

                </div>
            </div>
        </header>
    );
};

export default Header;
